<div class="panel-container" #positionsGrid [ngClass]="{'ets-hidden': !isActive}">
   <ag-grid-angular class="ag-theme-balham-dark" [gridOptions]="gridOptions"></ag-grid-angular>
</div>